/**
 * 将一位数字字符串转化成两位,在前面加0
 *
 */
function one2two(val) {
  val = val.toString();
  if (val.length < 2) {
    return `0${val}`;
  }
  return val;
}

export function formatTime(time) {
  time = time.valueOf();
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } if (diff < 3600) {
    return `${Math.ceil(diff / 60)}分钟前`;
  } if (diff < 3600 * 24) {
    return `${d.getHours}:${d.getMinutes}`;
  } if (diff < 3600 * 24 * 2) {
    return '昨天';
  } if (diff < 3600 * 24 * 3) {
    return '前天';
  } if (3600 * 24 * 8 <= diff && diff < 3600 * 24 * 30 * 12) {
    return `${one2two(d.getMonth() + 1)}-${one2two(d.getDay())}`;
  }
  const year = d.getFullYear().toString();

  return `${year.substr(year.length - 2, 2)}年${one2two(d.getMonth() + 1)}月`;
}
